import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

const responseInterceptor = response => response.data

const errorInterceptor = (error) => {
  // Network errors
  if (!error.response) {
    return Promise.reject(new Error('An unexpected error has occurred. Please try refreshing the page before trying again.'))
  }

  return Promise.reject(error.response.data.error)
}

instance.interceptors.response.use(responseInterceptor, errorInterceptor)

export default instance
